var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgU3AIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3,18A4.07,4.07,0,0,1,.71,16.48a4.52,4.52,0,0,1-.71-3V7.31H2.11V13.5a3.07,3.07,0,0,0,.39,1.95,2.37,2.37,0,0,0,2,.74,2.41,2.41,0,0,0,2.13-.86c.22-.32.29-.76.29-1.95V7.31H9v6.07c0,1.9-.2,2.62-.91,3.34A5.23,5.23,0,0,1,4.3,18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.85,12.35H9.64V10.57H14a2.26,2.26,0,0,0,1.51-.32,1.19,1.19,0,0,0,.43-1,1.28,1.28,0,0,0-.54-1.14,3.09,3.09,0,0,0-1.61-.29H10.63V6.07H14c.93,0,1.26-.05,1.53-.25a1.17,1.17,0,0,0,.52-1,1,1,0,0,0-.58-1,3.74,3.74,0,0,0-1.33-.17H9.64V1.84h4.6a5.16,5.16,0,0,1,2.63.44A2.69,2.69,0,0,1,18.15,4.7,2.33,2.33,0,0,1,16.76,7a2.35,2.35,0,0,1,1.36,2.38,2.87,2.87,0,0,1-1.46,2.55A5,5,0,0,1,13.85,12.35Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24,22.5H21.77l-1-2.61H16.34L15.28,22.5H13L17.39,12h2.44Zm-7-4.38h3l-1.48-4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgU3AIcon2);
export default __webpack_public_path__ + "static/media/U3AIcon2.b8bee6cdd8d4c7226eb03eedfa3a4f30.svg";
export { ForwardRef as ReactComponent };